const User = {
  install (Vue) {
    Vue.mixin({
      methods: {
        hasAuth (role) {
          const user = this.$store.state.user
          if (!role) {
            return true
          }

          if (!user.roles) {
            return false
          }

          return user.roles.includes(role)
        }
      },
      data () {
        var user
        if (!this.$store) {
          user = {isAnonymous: true}
        } else {
          user = this.$store.state.user
        }
        return {
          user: user
        }
      }
    })
  }
}

export default User
